<template>
  <el-dialog
    top="15vh"
    class="device-history__dialog"
    :title="$t('Device.historyData')"
    width="900px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <div class="header">
      <div class="search">
        <el-select
          v-model="timeType"
          :placeholder="$t('Common.tipsSelect1')"
          size="small"
          @change="handleTimeType"
        >
          <el-option :label="`1 ${$t('Device.hour')}`" :value="1"> </el-option>
          <el-option :label="`1 ${$t('Device.day')}`" :value="2"> </el-option>
          <el-option :label="`7 ${$t('Device.day')}`" :value="3"> </el-option>
          <el-option :label="$t('Device.custom')" :value="4"> </el-option>
        </el-select>
        <el-date-picker
          v-if="timeType === 4"
          size="small"
          v-model="date"
          type="datetimerange"
          range-separator="~"
          :start-placeholder="$t('Common.startTime')"
          :end-placeholder="$t('Common.endTime')"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleDate"
        >
        </el-date-picker>
      </div>
      <div class="toggle">
        <div class="toggle-item" :class="{ active: type === 'table' }" @click="toggle('table')">
          {{ $t('Device.table') }}
        </div>
        <div class="toggle-item " :class="{ active: type === 'chart' }" @click="toggle('chart')">
          {{ $t('Device.chart') }}
        </div>
      </div>
    </div>
    <div class="chart" v-if="type === 'chart'" v-loading="chartLoading">
      <div id="chart" v-if="xaxisData.length > 0"></div>
      <Empty v-else style="margin:auto;" />
    </div>
    <CommonTable
      v-if="type === 'table'"
      ref="table"
      :data="tableData"
      :total="total"
      @change="handleTableChange"
      :table-json="tablejson"
    >
    </CommonTable>
  </el-dialog>
</template>

<script>
import * as echarts from 'echarts'
import dayjs from 'dayjs'
import formTableMixin from '@/mixins/formTableMixin'
import tablejson from './Model/Tablejson.ShadowHistory'
import Empty from '@/components/Empty'
export default {
  mixins: [formTableMixin],
  components: {
    Empty
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  data() {
    return {
      tablejson,
      timeType: 1,
      date: [],
      type: 'table',
      xaxisData: [],
      yaxisData: [],
      queryApi: this.$api.iceDevice.iceDevice_shadow_history_list,
      chartLoading: false
    }
  },
  mounted() {
    this.setDate()
    this.init()
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    toggle(type) {
      this.type = type
      this.init()
    },
    handleTimeType() {
      this.setDate()
      this.init()
    },
    handleDate() {
      this.init()
    },
    setDate() {
      let endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      let startTime = ''
      if (this.timeType === 1) {
        // 1小时
        startTime = dayjs()
          .subtract(1, 'hour')
          .format('YYYY-MM-DD HH:mm:ss')
      } else if (this.timeType === 2) {
        // 1天
        startTime = dayjs()
          .subtract(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      } else if (this.timeType === 3) {
        // 7天
        startTime = dayjs()
          .subtract(7, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      } else {
        // 自定义查所有的
        endTime = ''
      }
      this.date = [startTime, endTime]
    },
    init() {
      if (this.type === 'table') {
        this.formSearch()
      } else {
        this.queryChartData().then(() => {
          this.initChart()
        })
      }
    },
    initChart() {
      const chartDom = document.getElementById('chart')
      if (!chartDom) return
      const myChart = echarts.init(chartDom)
      const option = {
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#666666'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#999'
            }
          },
          data: this.xaxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#666666'
          }
        },
        grid: {
          top: 16,
          bottom: 24,
          left: 68,
          right: 24
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            data: this.yaxisData,
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              color: '#339DFF',
              width: 3,
              shadowColor: 'rgba(101,110,125,0.15)',
              shadowBlur: 8,
              shadowOffsetX: 0,
              shadowOffsetY: 10
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    queryChartData() {
      this.chartLoading = true
      const params = {
        deviceId: this.$route.query.id,
        identifier: this.row.identifier,
        startTime: this.date[0],
        endTime: this.date[1]
      }
      return this.$ajax
        .get(this.$api.iceDevice.iceDevice_shadow_history_chart, params)
        .then((res) => {
          if (res.data) {
            this.xaxisData = res.data.map((item) => this.formatXaxis(item.createTime))
            this.yaxisData = res.data.map((item) => item.something)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.chartLoading = false
        })
    },
    formatXaxis(value) {
      const startTime = dayjs(this.date[0]).valueOf()
      const endTime = dayjs(this.date[1]).valueOf()
      if (endTime - startTime <= 86400000) {
        return dayjs(value).format('HH:mm')
      } else {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    formSearch() {
      const params = {
        deviceId: this.$route.query.id,
        identifier: this.row.identifier,
        startTime: this.date[0],
        endTime: this.date[1]
      }
      this.search(params, null, this.queryApi)
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.search {
  display: flex;
  .el-select {
    width: 120px;
  }
  .el-date-editor.el-input__inner {
    margin-left: 20px;
    width: 380px;
  }
}
.toggle {
  display: flex;
  flex-shrink: 0;
}
.toggle-item {
  margin-left: 8px;
  padding: 0 8px;
  line-height: 24px;
  font-size: 14px;
  color: #666666;
  cursor: pointer;
  &.active {
    font-weight: 600;
    color: #ffffff;
    background-image: linear-gradient(-26deg, $--color-cyanblue 0%, $--color-blue 100%);
    border-radius: 12px;
  }
}
.chart {
  width: 100%;
}
#chart {
  height: 300px;
  width: 100%;
}
</style>
